import React, { useEffect, useState } from 'react'
import { useSpring, animated } from 'react-spring'
import hokuroImage from '../../imports/hokuro'
import hokuroName from '../list/hokuroName'
import hokuro from '../../img/parts/ほくろ3.png'

const HokuroArray = () => {
  const [loading, setLoading] = useState(true)
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [scroll, setScroll] = useState<string>('visible')

  const hokuroImages: string[] = hokuroImage()
  const hokuroNames: string[] = hokuroName()

  document.body.style.overflow = scroll

  const openModal = (index: number) => {
    setSelectedImage(hokuroImages[index])
    setScroll('hidden')
  }

  const closeModal = () => {
    setSelectedImage(null)
    setScroll('visible')
  }

  const scaleAnimation = useSpring({
    transform: `scale(${selectedImage ? 1 : 0.5})`,
  })

  const backgroundAnimation = useSpring({
    opacity: selectedImage ? 1 : 0,
    backgroundColor: selectedImage ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0)',
  })

  const download = async () => {
    const imageUrls = hokuroImage()

    try {
      await Promise.all(
        imageUrls.map((url) => {
          return new Promise((resolve) => {
            const IllustBox = new Image()
            IllustBox.src = url
            IllustBox.onload = () => {
              resolve(null)
            }
          })
        }),
      )
    } finally {
      // ロード完了後、ローディング状態を終了
      setLoading(false)
    }
  }
  useEffect(() => {
    download()
  }, [])

  if (loading) {
    return (
      <div className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
        {/* <div className="h-10 w-10 animate-spin rounded-full border-4 border-nemoBlue border-t-transparent"></div> */}
        <img
          src={hokuro}
          alt=""
          className="h-10 w-10 animate-spin object-contain "
        />
      </div>
    )
  }
  return (
    <>
      {hokuroImages.map((image, index) => (
        <div
          className="relative transform cursor-pointer items-center rounded-xl shadow transition-transform duration-300 hover:scale-105"
          onClick={() => openModal(index)}
        >
          <div className="absolute bottom-0 right-0 flex flex-col items-end p-2">
            <div
              className={`rounded-xl bg-blue-200  px-2 text-xs text-nemoBlue xl:text-base xl:font-bold ${
                hokuroNames[index] === '　' ? `bg-opacity-0` : `bg-opacity-100`
              }`}
            >
              {hokuroNames[index]}
            </div>
          </div>
          <img
            key={index}
            src={image}
            alt={`msgImage ${index}`}
            className=" aspect-square rounded-xl bg-blue-200 bg-opacity-30 object-contain"
          />
        </div>
      ))}

      {selectedImage && (
        <div>
          <animated.div
            style={backgroundAnimation}
            className="fixed left-0 top-0 flex h-full w-full items-center justify-center"
            onClick={closeModal}
          >
            <animated.img
              src={selectedImage}
              alt="Selected Image"
              className="aspect-square rounded-xl bg-blue-200 bg-opacity-70 object-contain p-4 sm:h-3/4"
              style={scaleAnimation}
            />
          </animated.div>
        </div>
      )}
    </>
  )
}

export default HokuroArray
